angular.module('mercury.modules.reports.reconciliations')
.factory('PosTenders', ["$resource", "settings", "userinfo", function($resource, settings, userinfo) {

  function posTenders() {
    if (userinfo.companyPos() === 'Cloudpos') {
      return $resource(settings.mercHost + '/pos/tenders');
    }

    return $resource(settings.apiHost + '/r/PosTenders');
  }

  var PosTenderSurcharges = $resource(settings.mercHost + '/pos/tenders/surcharges');

  function get(start, end) {
    return posTenders().query({start: start, end: end}).$promise;
  }

  function getByIntervalForTenderType(start, end, interval, posIdentifier) {
    if (userinfo.companyPos() === 'Cloudpos') {
      return $resource(settings.mercHost + '/pos/tenders/' + posIdentifier)
        .query({start: start, end: end, interval: interval}).$promise;
    }

    return posTenders().query({start: start, end: end, interval: interval, posIdentifier: posIdentifier}).$promise;
  }

  function getSurcharges(start, end) {
    return PosTenderSurcharges.query({start: start, end: end}).$promise;
  }

  return {
    get: get,
    getByIntervalForTenderType: getByIntervalForTenderType,
    getSurcharges: getSurcharges
  };
}]);
